import { Config } from '../../src/types';

export default {
  store: {
    state: {
      features: {
        ageMatching: true,
      },
      copy: {
        name: 'Lifetime',
      },
      tooltips: {
        salaryInput: '',
        annualMonthly: '',
      },
    },
  },

  hooks: {
  //   beforeInitialise(vm, store, router) {},
  //   afterInitialise(vm, store, router) {},
  },
} as Config;
